import React from 'react';
import Video from './home/Video';
import Banner from './home/Banner';
import Awards from './home/Awards';
import Hero from './home/Hero';
import Contact from './home/Contact';

function Home() {
  return (
    <div>
      <Video />
      <Banner />
      <Awards />
      <Hero />
      <Contact />
    </div>
  );
}

export default Home;
